import { api } from './api';

export interface CadencEZNotification {
  id: string;
  userId: string;
  workspaceId: string | null;
  kind: string;
  title: string;
  body: string;
  link: string | null;
  readAt: string | null;
  createdAt: string;
}

export const notificationsApi = {
  async list(unreadOnly = false): Promise<CadencEZNotification[]> {
    const r = await api.get<CadencEZNotification[]>('/api/notifications', { params: { unreadOnly: unreadOnly ? 'true' : undefined } });
    return r.data;
  },
  async markRead(ids: string[]): Promise<{ markedRead: number }> {
    const r = await api.post<{ markedRead: number }>('/api/notifications/mark-read', { ids });
    return r.data;
  },
};
